import React, { useEffect } from 'react'
import { motion, useAnimation, useTransform } from 'framer-motion'
import yg from '/yg.svg'
import ya1 from '/ya1.svg'
import yl from '/yl.svg'
import ya2 from '/ya2.svg'
import yn from '/yn.svg'
import yt from '/yt.svg'
import yi from '/yi.svg'
import ys from '/ys.svg'
import ontour from '../assets/ontour.svg'
import { useLocation } from 'react-router-dom'

const YG = ({ smoothY, inView, mode }) => {

  const pathname = useLocation()

const move = useTransform(smoothY, v => {
  const start = 450
  const speed = 0.8

  if (v < start) return 0
  return -(v - start) * speed
})


  // console.log(inView)

  const animation = useAnimation()
  const animation2 = useAnimation()
  const animation3 = useAnimation()
  const animation4 = useAnimation()

  
  useEffect(() => {
      if(!inView){
          animation.start({ y: '-300%', filter: 'blur(5px)', transition: { ease: [0.9, 0.5, 0, 0.8], duration: 1, } })
          animation2.start({ y: '-180%', filter: 'blur(0.5px)', transition: { ease: [0.9, 0.5, 0, 0.8], duration: 1} })
          animation3.start({ y: '-40%', transition: { ease: [0.9, 0.5, 0, 0.8], duration: 1, delay: 0.6} })
          animation4.start({ y: '-40%', transition: { ease: [0.9, 0.5, 0, 0.8], duration: 1, delay: 0.8} })
      }
      if(inView){
          animation.start({ y: '0%', filter: 'blur(0.5px)', transition: { ease: [0.9, 0.5, 0, 0.8], duration: 0.5,  } })
          animation2.start({ y: '0%', filter: 'blur(5px)', transition: { ease: [0.9, 0.5, 0, 0.8], duration: 0.5 } })
          animation3.start({ y: '0%', transition: { ease: [0.9, 0.5, 0, 0.8], duration: 0.5 } })
          animation4.start({ y: '0%', transition: { ease: [0.9, 0.5, 0, 0.8], duration: 0.5 } })
      }
  }, [inView])




return (
    <>
    <div style={{ position: 'fixed', height: '100vh', height: '100svh', width: '100vw', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 2, pointerEvents: 'none' }}>
      <motion.div style={{ width: 'clamp(260px, 70vw, 50vw)', aspectRatio: '4 / 1', display: 'flex', flexDirection: 'column', justifyContent: 'center', position: 'absolute', zIndex: 2, y: move }}>
        <div style={{ overflow: 'hidden', height: '100%' }}>
          <motion.div style={{ position: 'relative', height: '50%', marginTop: '1%' }} animate={ animation }>
            <motion.div initial={ mode === 'tour' ? { opacity: 0 } : { opacity: 1 }} animate={{ opacity: 1, transition: { delay: 2 } }} style={{ height: '100%' }}>
            <motion.div initial={{ y: 300 }} animate={{ y: 0, transition: { delay: 0.500, ease: [0.9, 0.5, 0, 0.95], duration: 0.9 } }} style={{ position: 'absolute', width: '100%' }}>
              <svg style={{ fill: '#fff000' }} id="Layer_1" xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 582.21 116.81">
                <path className="st0" d="M70.5,95.43c-2.02.58-4.05,1.16-5.5,1.45-2.02.29-3.76.58-4.92.58-4.05,0-8.68-1.16-13.02-3.18-4.63-2.02-8.97-5.21-12.44-8.97h0c-6.65-6.94-10.41-16.49-10.41-26.9,0-12.73,6.07-24.3,15.91-31.24,6.94-4.92,14.75-7.52,23.14-7.52,4.92,0,9.55,1.16,14.46,3.47l2.89,1.45V4.89s-1.45-.29-1.45-.29c-5.21-1.45-10.41-2.31-15.33-2.31-8.68,0-16.78,1.45-24.01,4.34-7.23,2.89-13.6,6.94-19.09,12.44h0C10.33,29.48,4.26,43.94,4.26,58.69c0,14.75,5.79,29.22,16.49,39.63,5.21,5.21,11.28,9.26,17.65,12.15,6.65,2.6,13.88,4.05,21.41,4.05,10.7,0,19.96-2.6,28.06-8.1l.87-.58v-49.18s-18.51,0-18.51,0v38.76h.29Z"/>
                <path className="st0" d="M20.75,19.06h0Z"/>
                <path className="st0" d="M20.75,98.03h0Z"/>
              </svg>
            </motion.div>
            <motion.div initial={{ y: 300 }} animate={{ y: 0, transition: { delay: 0.540, ease: [0.9, 0.5, 0, 0.95], duration: 0.9 } }} style={{ position: 'absolute', width: '100%' }}>
              <svg style={{ fill: '#fff000' }} id="Layer_1" xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 582.21 116.81">
                <path class="st0" d="M91.91,112.21h19.67s7.52-20.54,7.52-20.54h30.37s7.52,20.54,7.52,20.54h1.45s17.93,0,17.93,0L135.59,3.73l-43.68,108.48ZM143.69,72.87h-17.36s9.26-23.43,9.26-23.43l8.1,23.43Z"/>
              </svg>
            </motion.div>
            <motion.div initial={{ y: 300 }} animate={{ y: 0, transition: { delay: 0.580, ease: [0.9, 0.5, 0, 0.95], duration: 0.9 } }} style={{ position: 'absolute', width: '100%' }}>
              <svg style={{ fill: '#fff000' }} id="Layer_1" xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 582.21 116.81">
                <polygon class="st0" points="199.81 4.6 180.42 4.6 180.42 6.33 180.42 112.21 232.49 112.21 232.49 92.83 199.81 92.83 199.81 4.6"/>
              </svg>
            </motion.div>
            <motion.div initial={{ y: 300 }} animate={{ y: 0, transition: { delay: 0.620, ease: [0.9, 0.5, 0, 0.95], duration: 0.9 } }} style={{ position: 'absolute', width: '100%' }}>
              <svg style={{ fill: '#fff000' }} id="Layer_1" xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 582.21 116.81">
                <path class="st0" d="M236.54,112.21h19.67s7.52-20.54,7.52-20.54h30.37s7.52,20.54,7.52,20.54h1.45s17.93,0,17.93,0L280.22,3.73l-43.68,108.48ZM288.03,72.87h-17.36s9.26-23.43,9.26-23.43l8.1,23.43Z"/>
              </svg>
            </motion.div>
            <motion.div initial={{ y: 300 }} animate={{ y: 0, transition: { delay: 0.640, ease: [0.9, 0.5, 0, 0.95], duration: 0.9 } }} style={{ position: 'absolute', width: '100%' }}>
              <svg style={{ fill: '#fff000' }} id="Layer_1" xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 582.21 116.81">
                <polygon class="st0" points="385.23 70.26 325.35 3.15 325.35 8.36 325.35 112.21 344.73 112.21 344.73 53.49 404.61 114.52 404.61 4.6 385.23 4.6 385.23 70.26"/>
              </svg>
            </motion.div>
            <motion.div initial={{ y: 300 }} animate={{ y: 0, transition: { delay: 0.680, ease: [0.9, 0.5, 0, 0.95], duration: 0.9 } }} style={{ position: 'absolute', width: '100%' }}>
              <svg style={{ fill: '#fff000' }} id="Layer_1" xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 582.21 116.81">
                <polygon class="st0" points="410.68 23.69 434.98 23.69 434.98 112.21 455.23 112.21 455.23 23.69 479.24 23.69 479.24 4.6 410.68 4.6 410.68 23.69"/>
              </svg>
            </motion.div>
            <motion.div initial={{ y: 300 }} animate={{ y: 0, transition: { delay: 0.720, ease: [0.9, 0.5, 0, 0.95], duration: 0.9 } }} style={{ position: 'absolute', width: '100%' }}>
              <svg style={{ fill: '#fff000' }} id="Layer_1" xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 582.21 116.81">
                <polygon class="st0" points="484.74 6.33 484.74 112.21 504.12 112.21 504.12 4.6 484.74 4.6 484.74 6.33"/>
              </svg>
            </motion.div>
            <motion.div initial={{ y: 300 }} animate={{ y: 0, transition: { delay: 0.780, ease: [0.9, 0.5, 0, 0.95], duration: 0.9 } }} style={{ position: 'absolute', width: '100%' }}>
              <svg style={{ fill: '#fff000' }} id="Layer_1" xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 582.21 116.81">
                <path class="st0" d="M576.15,66.5c-.87-2.6-2.31-4.92-3.76-7.23-2.31-3.18-5.79-6.07-9.55-8.39s-8.39-4.63-13.88-6.65h0c-5.21-2.02-9.26-4.05-11.86-6.07-1.16-1.16-2.31-2.31-2.89-3.47-.58-1.16-.87-2.6-.87-4.34,0-2.6,1.16-4.92,2.89-6.65,1.74-1.74,4.34-2.89,7.52-2.89,2.6,0,4.92.87,6.65,2.31,1.74,1.45,3.18,3.76,4.05,6.65l.58,2.31,17.36-7.23-.58-1.74c-2.31-6.65-6.07-11.86-10.99-15.33-4.92-3.47-10.99-5.5-17.65-5.5-7.81,0-15.04,3.18-20.25,8.39-5.21,5.21-8.68,12.44-8.68,20.54,0,3.76.87,7.52,2.6,10.99,1.74,3.76,3.76,7.23,6.65,9.84s5.79,4.63,8.68,6.07c2.89,1.45,6.07,2.31,8.97,3.47h0c3.18,1.16,5.79,2.31,8.1,3.18,1.74.87,3.18,1.74,4.34,2.6,1.74,1.45,2.89,2.89,3.76,4.63s1.16,4.05,1.16,6.94c0,4.63-1.45,8.68-4.05,11.28-1.45,1.45-2.89,2.31-4.92,3.18-2.02.87-4.05,1.16-6.65,1.16-2.31,0-4.05-.29-5.79-1.16-2.6-.87-4.63-2.6-6.36-5.21-1.74-2.6-2.89-6.07-3.76-10.41l-.29-2.6-2.31,1.16-15.62,6.65.29,1.45c1.74,8.97,6.07,16.2,12.15,21.41,6.07,4.92,13.6,7.81,22.27,7.81,9.55,0,18.22-3.76,24.3-10.12,6.36-6.36,10.12-15.33,10.12-25.75.29-3.76-.29-7.81-1.74-11.28Z"/>
              </svg>
            </motion.div>
            </motion.div>
          </motion.div>
          
          <motion.div animate={ animation2 } style={{ color: '#fff000', display: 'flex', position: 'relative', justifyContent: 'center', top: '100%', width: '100%' }}>
            <div style={{ width: '100%', marginTop: '12px' }}>
              <img src={ ontour } style={{ width: '100%' }} /> 
            </div>
            <div style={{ bottom: '-35px', left: '0',  position: 'absolute', overflow: 'hidden', height: '40px' }}><motion.div style={{ height: '100%' }} animate={ animation3 }><h5>"JUST</h5></motion.div></div>
            <div style={{ bottom: '-35px', right: '0', position: 'absolute', overflow: 'hidden', height: '40px' }}><motion.div style={{ height: '100%' }} animate={ animation4 }><h5>U&I"</h5></motion.div></div>
          </motion.div>
        </div>
      </motion.div>
    </div>
    </>
)    

}

export default YG